import { render, staticRenderFns } from "./AcademyEntry.vue?vue&type=template&id=2856b330&scoped=true&"
import script from "./AcademyEntry.vue?vue&type=script&lang=js&"
export * from "./AcademyEntry.vue?vue&type=script&lang=js&"
import style0 from "./AcademyEntry.vue?vue&type=style&index=0&id=2856b330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856b330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VLayout,VRow})
